import styled, { keyframes, css } from 'styled-components'

export const fadeInKeyframes = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1.0;
  }
`

interface Props {
  /** フェードイン速度。デフォルト = "0.5s" */
  speed?: string
}

export const FadeIn = styled.div<Props>`
    animation: ${fadeInKeyframes} ${props => props.speed || '0.5s'} linear;
    width: 100%;
    height: 100%;
`

export const fadeIn = css`
    animation: ${fadeInKeyframes} 0.5s linear;
`

const skeltonAnim = keyframes`
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(100%);
    }
`;

export const skelton = css`
  background: transparent;
  position: relative;
  overflow: hidden;
  z-index: 1;

  &:before {
        content: "";
        animation: ${skeltonAnim} 1s linear infinite;
        height: 100%;
        left: 0;
        z-index: 2;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(-100%);
        background: linear-gradient(to right, transparent 0%, #E8E8E8 50%, transparent 100%);
  }
`